import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, personalInfo, REQUIRED } from "./utils";
import * as PANAMA from "../../onboarding/profile-info/form/pa/constants.pa";

export const panamaFields = {
  paCedula: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "paCedula",
    label: "Cédula (Cedula)",
    validations: {
      required: {
        when: {
          nationality: (value) => value === "PA",
        },
      },
    },
    hideWhen: {
      nationality: (value) => value !== "PA",
    },
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paCedula", ""),
  }),
  paPassport: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "paPassport",
    label: "Passport Number",
    validations: {
      required: {
        when: {
          nationality: (value) => value !== "PA",
        },
      },
    },
    hideWhen: {
      nationality: (value) => value === "PA",
    },
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paPassport", ""),
  }),
  paCivilStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "paCivilStatus",
    label: "Civil Status",
    placeholder: "Select civil status",
    options: PANAMA.CIVIL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paCivilStatus", ""),
  }),
  paGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "paGender",
    label: "Gender",
    placeholder: "Select gender",
    options: PANAMA.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paGender", ""),
  }),
  paEducationLevel: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "paEducationLevel",
    label: "Education Level",
    placeholder: "Select education level",
    options: PANAMA.EDUCATION_LEVEL_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paEducationLevel", ""),
  }),
  paSocialInsuranceNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "paSocialInsuranceNumber",
    label: "Social Insurance Number",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paSocialInsuranceNumber", ""),
  }),
};
